import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "flex flex-col mt-4 bg-white rounded containerDiv" }
const _hoisted_4 = { class: "border border-lightgrey rounded" }
const _hoisted_5 = { class: "justify-between flex px-5 h-8 m-2" }
const _hoisted_6 = { class: "flex justify-end gap-3" }
const _hoisted_7 = { class: "rounded flex text-xs pt-1 p-5 m-2" }
const _hoisted_8 = { class: "w-2/5" }
const _hoisted_9 = { class: "mt-3 border border-lightgrey option mr-1 displayContainer overflow-y-scroll rounded" }
const _hoisted_10 = {
  key: 0,
  class: "p-2"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-xs" }
const _hoisted_13 = { class: "w-3/5" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "w-full pt-0" }
const _hoisted_16 = { class: "mt-3 displayContainer border flex-col text-sm border-lightgrey overflow-y-scroll ml-1 rounded" }
const _hoisted_17 = {
  key: 0,
  class: "p-2"
}
const _hoisted_18 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_19 = ["value", "id", "onChange"]
const _hoisted_20 = ["for"]
const _hoisted_21 = {
  key: 0,
  class: "p-5 m-2"
}
const _hoisted_22 = { class: "tableCornerRadius bg-white" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_25 = ["colspan"]
const _hoisted_26 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_27 = {
  key: 0,
  class: "rounded h-5 w-26"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "flex rounded w-32 items-center justify-center py-1 regular text-xs" }
const _hoisted_30 = { class: "text-xs" }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "flex rounded w-32 py-1 regular text-xs" }
const _hoisted_33 = { class: "text-xs" }
const _hoisted_34 = { key: 3 }
const _hoisted_35 = { key: 4 }
const _hoisted_36 = { key: 5 }
const _hoisted_37 = { key: 6 }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "buttonposition flex justify-end items-center px-5 mx-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "row w-full justify-between flex" }, [
        _createElementVNode("div", { class: "title flex items-center" }, [
          _createElementVNode("h1", null, "Information Mapping")
        ])
      ], -1)),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mt-3 text-xs" }, " The Global Risks Report 2022, 17th Edition, is published by the World Economic Forum. The information in this report, or on which this report is based, has been obtained from sources that the authors believe to be reliable and accurate. However, it has not been independently verified and no representation or warranty, express or implied, is made as to the accuracy or completeness of any information obtained from third parties. ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex my-3" }, [
              _createElementVNode("h2", { class: "header cursor-pointer" }, "Information Mapping")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(_ctx.checkedInformationIds.length>0 ? 'btnprimary' :'btndisabled pointer-events-none'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addSelectedInformation()))
              }, "Add", 2),
              _createElementVNode("button", {
                class: "filterButton flex",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickOnFilters()))
              }, _cache[9] || (_cache[9] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "filterIcon"
                }, null, -1),
                _createTextVNode("Filters")
              ]))
            ])
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5 mt-2 mb-2" }, null, -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "flex",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('informationCategory')))
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "header cursor-pointer" }, "Category", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'informationCategory' ? _ctx.classSort : 'opacity-50'])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.showFilters)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "inputboxstyling",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.categoryFilters.informationCategory) = $event)),
                        placeholder: "Search Category"
                      }, null, 512), [
                        [_vModelText, _ctx.categoryFilters.informationCategory]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (category, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "rounded"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["p-3 pl-5 cursor-pointer", _ctx.selectedCategory == category ? 'bg-primary hover:bg-primary text-white' : 'hover:bg-lightgrey']),
                      onClick: ($event: any) => (_ctx.selectedCategory = category)
                    }, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(category), 1)
                    ], 10, _hoisted_11)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "flex",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort('information')))
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "header cursor-pointer" }, "Information", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'information' ? _ctx.classSort : 'opacity-50'])
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.showFilters)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "inputboxstyling",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.infoFilters.information) = $event)),
                          placeholder: "Search Information"
                        }, null, 512), [
                          [_vModelText, _ctx.infoFilters.information]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryWiseInfoList, (infoObj, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "h-7 flex justify-normal items-center cursor-pointer p-5 hover:bg-lightgrey",
                      key: infoObj._id
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkedInformationIds) = $event)),
                          value: infoObj._id,
                          id: index,
                          type: "checkbox",
                          class: "checkbox",
                          onChange: ($event: any) => (_ctx.handleCheckboxChange(infoObj._id))
                        }, null, 40, _hoisted_19), [
                          [_vModelCheckbox, _ctx.checkedInformationIds]
                        ]),
                        _createElementVNode("label", {
                          for: index,
                          class: "pl-3 cursor-pointer"
                        }, _toDisplayString(infoObj.information), 9, _hoisted_20)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        (_ctx.selectedInformation.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (presentColumn) => {
                      return (_openBlock(), _createElementBlock("th", {
                        scope: "col",
                        key: presentColumn,
                        class: _normalizeClass(_ctx.getHeaderwidth(presentColumn))
                      }, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(presentColumn)), 1)
                      ], 2))
                    }), 128))
                  ]),
                  (_ctx.selectedInformation.length == 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
                        _createElementVNode("tr", _hoisted_24, [
                          _createElementVNode("td", {
                            class: "relative h-10",
                            colspan: _ctx.columnNames.size
                          }, _cache[14] || (_cache[14] = [
                            _createElementVNode("div", { class: "flex justify-center" }, [
                              _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                            ], -1)
                          ]), 8, _hoisted_25)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedInformation, (row, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            class: "cursor-pointer rowHeight"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (presentColumn) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: presentColumn,
                                class: "cursor-pointer relative"
                              }, [
                                (row[presentColumn] == '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString('N/A')))
                                  : (presentColumn=='informationCategory')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.getInfocategorydetails(row)), 1)
                                        ])
                                      ]))
                                    : (presentColumn=='information')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "w-full h-full absolute opacity-10 rounded" }, null, -1)),
                                          _createElementVNode("div", _hoisted_32, [
                                            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.getInformationdetails(row)), 1)
                                          ])
                                        ]))
                                      : (presentColumn=='confidentiality')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass([_ctx.colorRiskBg(row[presentColumn]), "flex items-center justify-center relative rounded w-28 px-2.5 h-5 regular"])
                                            }, [
                                              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "w-full h-full absolute opacity-10 rounded" }, null, -1)),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["flex rounded w-32 items-center justify-center py-1 regular text-xs", _ctx.colorRiskText(row[presentColumn])])
                                              }, _toDisplayString(_ctx.dbConfidentiality.find((l) => {
                                                return l.value == row[presentColumn];
                                            })?.key), 3)
                                            ], 2)
                                          ]))
                                        : (presentColumn=='integrity')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass([_ctx.colorRiskBg(row[presentColumn]), "flex items-center justify-center relative rounded w-28 px-2.5 h-5 regular"])
                                              }, [
                                                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "w-full h-full absolute opacity-10 rounded" }, null, -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex rounded w-32 items-center justify-center py-1 regular text-xs", _ctx.colorRiskText(row[presentColumn])])
                                                }, _toDisplayString(_ctx.dbIntegrity.find((l) => {
                                                return l.value == row[presentColumn];
                                            })?.key || 'N/A'), 3)
                                              ], 2)
                                            ]))
                                          : (presentColumn=='availability')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass([_ctx.colorRiskBg(row[presentColumn]), "flex items-center justify-center relative rounded w-28 px-2.5 h-5 regular"])
                                                }, [
                                                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "w-full h-full absolute opacity-10 rounded" }, null, -1)),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["flex rounded w-32 items-center justify-center py-1 regular text-xs", _ctx.colorRiskText(row[presentColumn])])
                                                  }, _toDisplayString(_ctx.dbAvailability.find((l) => {
                                                return l.value == row[presentColumn];
                                            }).key), 3)
                                                ], 2)
                                              ]))
                                            : (presentColumn == 'deleteinfo')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                  _createElementVNode("div", {
                                                    class: "flex justify-center h-5 w-5",
                                                    onClick: ($event: any) => (_ctx.deleteInfoRow(row))
                                                  }, _cache[19] || (_cache[19] = [
                                                    _createElementVNode("img", {
                                                      src: _imports_1,
                                                      class: "h-5 cursor-pointer w-5 mx-2.5"
                                                    }, null, -1)
                                                  ]), 8, _hoisted_38)
                                                ]))
                                              : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ]))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.selectedInformation.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["fixed bottom-7 bg-white h-16 flex justify-end items-center", { 'w-40': _ctx.isSidebarToggle, 'w-10': !_ctx.isSidebarToggle }])
        }, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              class: _normalizeClass(["btnprimary mr-1.5", JSON.stringify(_ctx.tableIds) == JSON.stringify(_ctx.existingInfoIds) ? 'btndisabled pointer-events-none' : 'btnprimary']),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onCancel()))
            }, "Reset", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["btnprimary", JSON.stringify(_ctx.tableIds) == JSON.stringify(_ctx.existingInfoIds) ? 'btndisabled pointer-events-none' : 'btnprimary']),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveMappedInformation()))
            }, "Save", 2)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}